import { projectStatusByCode } from 'entities';

import { Column, Dot } from 'components/Blocks';

import { ProjectDateChangeForm } from './Form';
import { ContentCard, ProjectLink } from '../components';

import { useLocalPendingEntries } from 'providers/PendingActions';

export function ProjectDateChange(): JSX.Element {
  const projectsToReview = useLocalPendingEntries('PROJECT_DATE_CHANGE');

  return (
    <Column>
      {projectsToReview.map((project) => (
        <ContentCard
          key={project.id}
          content={<ProjectDateChangeForm project={project} />}
          header={
            <>
              <Dot color={projectStatusByCode[project.status].color} size={16} />

              <ProjectLink id={project.id} text={project.name} />
            </>
          }
        />
      ))}
    </Column>
  );
}
